// Interface

import util from '@/utils/classToObject'
import { IGliderState } from './state'
import { AloDbGlider } from '@/models/alodb/AloDbGlider'
import { AloDbEnseigne } from '@/models/alodb/AloDbEnseigne';

export class GliderGetter {  
      
  public gliders(state:IGliderState,getters:any) {
    return state.gliders
  }

  public glidersById(state:IGliderState) {
    return state.gliders.reduce(
      (acc, glider) => {
        acc[glider.GLI_ID!] = glider
        return acc
      },
      {} as { [id: number]: AloDbGlider }
    )
  } 

  public modifiedAdmGlider(state:IGliderState,getters:any) {
    return state.modifiedAdmGlider
  }

  public originalAdmGlider(state:IGliderState,getters:any) {
    return state.originalAdmGlider
  }

  public gliderLoading(state:IGliderState,getters:any) {
    return state.gliderLoading
  }

  public gliderStatus(state:IGliderState,getters:any) {
    return state.status
  }
  

  public originalNsdConfigs(state:IGliderState) {
    return state.originalNsdConfigs
  }

  public modifiedNsdConfigs(state:IGliderState) {
    return state.modifiedNsdConfigs
  }

  public adminGliderFilter(state:IGliderState) {     
    return state.adminFilter
  }

  public originalFileTransfertConfigs(state:IGliderState) {
    return state.originalFileTransfertConfigs
  }

  public modifiedFileTransfertConfigs(state:IGliderState) {
    return state.modifiedFileTransfertConfigs
  }

  public nsdLoading(state:IGliderState) {
    return state.nsdLoading
  }

  public fileTransfertLoading(state:IGliderState) {
    return state.fileTransfertLoading
  }

  public ftpLoading(state:IGliderState) {
    return state.ftpLoading
  } 
  
  public rsyncLoading(state:IGliderState) {
    return state.rsyncLoading
  }

  public singleWayPointLoading(state:IGliderState) {
    return state.singleWayPointLoading
  }

  public expectedNMEALoading(state:IGliderState) {
    return state.expectedNMEALoading
  }
  
  public originalSingleWayPointConfigs(state:IGliderState) {
    return state.originalSingleWayPointConfigs
  }

  public modifiedSingleWayPointConfigs(state:IGliderState) {
    return state.modifiedSingleWayPointConfigs
  }

  public originalExpectedNMEAConfigs(state:IGliderState) {
    return state.originalExpectedNMEAConfigs
  }

  public modifiedExpectedNMEAConfigs(state:IGliderState) {
    return state.modifiedExpectedNMEAConfigs
  }

  public originalFtpConfigs(state:IGliderState) {
    return state.originalFtpConfigs
  }

  public modifiedFtpConfigs(state:IGliderState) {
    return state.modifiedFtpConfigs
  }

  public originalRsyncConfigs(state:IGliderState) {
    return state.originalRsyncConfigs
  }

  public modifiedRsyncConfigs(state:IGliderState) {
    return state.modifiedRsyncConfigs
  }

}

export default util.classToObject(GliderGetter)